import { render, staticRenderFns } from "./PosPT_Footer.vue?vue&type=template&id=27af3ed4"
import script from "./PosPT_Footer.vue?vue&type=script&lang=js"
export * from "./PosPT_Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports